<template>
	<nav class="menu" :class="this.$store.getters.menuToggle ? '' : 'hidden'">
		<div @click="toggleMenu" class="hide-icon">
			<img src="/img/sidebar-close.svg" alt="" />
		</div>
		<div>
			<a href="#" class="logo-container"><img class="logo" src="/img/logo.svg" alt="" /></a>
			<ul class="first-ul">
				<p class="navigation__description navigation__description--nomargin">Espaces privé</p>
				<li>
					<router-link :class="isActive.includes('/dashboard') ? 'active' : ''" to="/admin/dashboard"><img
							src="/img/dashboard.svg" alt="" /> Tableau de
						bord</router-link>
				</li>
				<li>
					<router-link
						ref="menuAdminClass"
						:class="checkUrl2 == true ? 'research-active' : ''"
						@click="setClassActive"
						class="flex-link"
						to="">
	
							<span>
								<img src="/img/classes.svg" alt="" />
								Classes
								<img class="arrow" src="/img/down-arrow.svg" alt="" />
							</span>
							<ul class="classes-container">
								<li v-for="classe in this.$store.state.classes" :key="classe">
									<router-link
										:class="isActiveParams == classe.id ? 'active' : ''"
										:to="{ name: 'ClassResources',params: { id: classe.id },}">
										{{ classe.name }}
									</router-link>
								</li>
								<li v-if="this.$store.state.user.role != 'GUEST' && !isSSO">
									<router-link to="/admin/ajouter-classe">
										+ Ajouter une classe</router-link>
								</li>
								<li v-else>
									<button v-if="!isSSO" @click="checkGuest">
										+ Ajouter une classe
									</button>
								</li>
							</ul>
					</router-link>
				</li>
								<li>
					<router-link :class="isActive.includes('/agenda') ? 'active' : ''" to="/admin/agenda"><img
							src="/img/calendar.svg" alt="" />
						Agenda</router-link>
				</li>
				<p class="navigation__description">Espaces de partage</p>
								
				<li>
					<router-link :class="isActive.includes('/share-place') ? 'active' : ''" to="/admin/share-place"><img
							src="/img/share-space.svg" alt="" />
						Partage de fichiers</router-link>
				</li>
				<li>
					<router-link :class="isActive.includes('/community-profiles') ? 'active' : ''" to="/admin/community-profiles">
						<img src="/img/classes.svg" alt="" />
						Communauté
					</router-link>
				</li>

				<p class="navigation__description">Espaces de création</p>
				<li>
					<router-link :class="isActive.includes('/questions-individuelles') ? 'active' : ''" to="/admin/recherche/questions-individuelles/a-la-carte">
						<img
							src="/img/flash.svg"
							alt="" />
						Questions flash
					</router-link>
				</li>
				<li v-if="showExpresso">
					<router-link :class="isActive.includes('/clef-en-main') ? 'active' : ''" to="/admin/recherche/clef-en-main">
						<img
							src="/img/coffee-cup.svg"
							alt="" />
						Activités expresso
					</router-link>
				</li>
				<li>
					<router-link :class="isActive.includes('/jeu-serieux') ? 'active' : ''" to="/admin/recherche/jeu-serieux">
						<img
							src="/img/game-controller.svg"
							alt="" />
						Jeu sérieux
					</router-link>
				</li>
								<li>
					<router-link :class="isActive.includes('/qcm') ? 'active' : ''" to="/admin/recherche/qcm">
						<img
							src="/img/game.svg"
							alt="" />
						QCM
					</router-link>
					</li>
			</ul>
			<user-display />
		</div>
		<user-display />
	</nav>
	<pop-up-jeu @closed="timeToCloseJeu" v-if="isVisibleJeu" />
</template>

<script>
import PopUpJeu from '../PopUp/PopUpJeu.vue'
import UserDisplay from '../Admin/UserDisplay.vue'
import Config from "../../config"

export default {
	components: {
		PopUpJeu,
		UserDisplay
	},
	data() {
		return {
			isVisibleJeu: false,
			classes: [],
			isClassActive: false,
			isCreateActive: false,
			isVisibleGuest: false,
			landing: Config.landing_url,
		}
	},

	mounted() {
		this.$store.state.isMenuToggled = true
	},

	methods: {
		toggleMenu() {
			this.$store.dispatch('toggleMenu')
		},
		checkGuest(e) {
			if (this.$store.state.user.role === 'GUEST') {
				this.isVisibleGuest = !this.isVisibleGuest
			}
			else {
				this.$router.push({ name: e })
			}
		},
		setCreateActive() {

			if (this.isCreateActive) {
				this.isCreateActive = false
			}
			else {
				this.isClassActive = false
				this.isCreateActive = true
			}
		},
		setClassActive() {
			if (this.isClassActive) {
				this.isClassActive = false
			}
			else {
				this.isCreateActive = false
				this.isClassActive = true
			}

		},
		showPopUpJeu() {
			this.isVisibleJeu = true
		},
		timeToCloseJeu() {
			this.isVisibleJeu = false
		},
	},
	computed: {
		isSSO() {
			return this.$store.getters.isSSO
		},
		
		isActive() {
			return this.$route.path
		},
		isActiveParams() {
			return this.$route.params.id
		},
		showExpresso() {
			// Simplified: check if subjects array contains the id 1
			const user = this.$store.state.user || null
			if (!user || !Array.isArray(user.subjects)) return false
			return user.subjects.includes(1)
		},
		checkUrl() {
			if ((this.$route.path.includes('/recherche/') || this.isCreateActive) && !this.isClassActive) {
				return true
			}
			else {
				return false
			}
		},
		checkUrl2() {
			if ((this.$route.path.includes('/classe/') || this.isClassActive) && !this.isCreateActive) {
				return true
			}
			else {
				return false
			}
		},
	},
}
</script>

<style></style>
